module.exports = __webpack_public_path__ + "fonts/835acef.ttf";